import { render } from "./ProfessionalList.vue?vue&type=template&id=295ad79c&scoped=true"
import script from "./ProfessionalList.vue?vue&type=script&lang=js"
export * from "./ProfessionalList.vue?vue&type=script&lang=js"

import "./ProfessionalList.vue?vue&type=style&index=0&id=295ad79c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295ad79c"]])

export default __exports__